const DAYS_ES = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

function padTime(n: number): string {
  return n.toString().padStart(2, '0');
}

export function cronToText(cron: string): string {
  const parts = cron.trim().split(/\s+/);
  if (parts.length !== 5) return cron;

  const [min, hr, dom, month, dow] = parts;

  const isEveryMinute = min === '*';
  const isEveryHour = hr === '*';
  const isEveryDom = dom === '*';
  const isEveryMonth = month === '*';
  const isEveryDow = dow === '*';

  const minute = parseInt(min, 10);
  const hour = parseInt(hr, 10);
  const time = `${padTime(isNaN(hour) ? 0 : hour)}:${padTime(isNaN(minute) ? 0 : minute)}`;

  // Every minute: * * * * *
  if (isEveryMinute && isEveryHour && isEveryDom && isEveryMonth && isEveryDow) {
    return 'Cada minuto';
  }

  // Hourly: X * * * *
  if (isEveryHour && isEveryDom && isEveryMonth && isEveryDow) {
    return `Cada hora en el minuto ${padTime(isNaN(minute) ? 0 : minute)}`;
  }

  // Daily: X X * * *
  if (isEveryDom && isEveryMonth && isEveryDow) {
    return `Diario a las ${time}`;
  }

  // Weekdays: X X * * 1-5
  if (isEveryDom && isEveryMonth && dow === '1-5') {
    return `Días hábiles a las ${time}`;
  }

  // Weekly on specific day: X X * * N
  if (isEveryDom && isEveryMonth && /^\d$/.test(dow)) {
    const dayName = DAYS_ES[parseInt(dow, 10)] ?? dow;
    return `Cada ${dayName} a las ${time}`;
  }

  // Monthly on specific day: X X N * *
  if (/^\d+$/.test(dom) && isEveryMonth && isEveryDow) {
    const day = parseInt(dom, 10);
    return `Día ${day} de cada mes a las ${time}`;
  }

  // Specific day-of-week range like 1-5 (already handled above) or other combos
  if (isEveryDom && isEveryMonth && /^\d+-\d+$/.test(dow)) {
    return `Días ${dow} a las ${time}`;
  }

  // Fallback for less common patterns
  const parts2: string[] = [];
  if (!isEveryDow && dow !== '*') {
    if (/^\d+$/.test(dow)) {
      parts2.push(`los ${DAYS_ES[parseInt(dow, 10)] ?? dow}`);
    } else {
      parts2.push(`días ${dow}`);
    }
  }
  if (!isEveryDom && dom !== '*') {
    parts2.push(`día ${dom}`);
  }
  if (!isEveryMonth && month !== '*') {
    parts2.push(`mes ${month}`);
  }
  parts2.push(time);

  return parts2.join(' · ');
}
